import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

type BuddiesCheckpointOpts = ViewOpts & {
  type: number;
  value: number;
  index: number;
};

export class BuddiesCheckpoint extends View {
  private icon: ImageScaleView;
  private label: LangBitmapFontTextView;
  private check: ImageScaleView;
  public value = 0;
  public index = 0;

  constructor(opts: BuddiesCheckpointOpts) {
    super({
      width: 100,
      height: 100,
      centerOnOrigin: true,
      ...opts,
    });

    this.value = opts.value;
    this.index = opts.index;

    this.icon = new ImageScaleView({
      superview: this,
      image: `assets/ui/buddies/popupBaking/milestone_mark.png`,
      scaleMethod: 'contain',
      width: 45,
      height: 45,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: this.style.height - 15,
    });

    this.label = new LangBitmapFontTextView({
      superview: this,
      x: this.icon.style.x - 2,
      y: this.icon.style.y - 5,
      align: 'center',
      verticalAlign: 'center',
      size: 22,
      font: 'Body',
      color: '#FFFFFF',
      width: this.icon.style.width,
      height: this.icon.style.height,
      centerOnOrigin: true,
      localeText: () => `${opts.index + 1}`,
    });

    this.check = new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/popupBaking/progress_check.png',
      scaleMethod: 'contain',
      width: 37,
      height: 34,
      centerOnOrigin: true,
      x: this.icon.style.x + 20,
      y: this.icon.style.y - 3,
      visible: false,
    });
  }

  public markAsChecked() {
    this.check.show();
  }
}
